import { Api } from '../api';
import { transactions } from '../endpoints';
import type { DownloadTransactionsRequest, GetCardTransactionsRequest, GetCardTransactionsResponse } from './models';

export class TransactionsApi extends Api {
  // static getTransactions = (id: string) => this.get<any[]>({ url: transactions.getTransactions(id) });

  static getCardTransactions = (request: GetCardTransactionsRequest) =>
    this.get<GetCardTransactionsResponse>({
      url: transactions.getCardTransactions(request.accountId, request.cardId),
      queryParams: { Index: request.index, Count: request.count },
    });

  static downloadTransactions = (request: DownloadTransactionsRequest) =>
    this.get<Blob>({
      url: transactions.downloadTransactions(request.accountId, request.cardId),
      queryParams: { From: request.From, To: request.To },
    });
}
